import { render, staticRenderFns } from "./work_item_popover.vue.js?vue&type=template&id=455c4492&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=template&id=455c4492&vue3"
import script from "./work_item_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js&vue3"
export * from "./work_item_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=script&lang=js&vue3"
import style0 from "./work_item_popover.vue.css?vue&type=style&index=0&id=455c4492&prod&lang=css&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_popover.vue?vue&type=style&index=0&id=455c4492&prod&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports